export const INVALID_PAYLOAD = 'INVALID_PAYLOAD';

export const MENU_REQ = '@MENU/MENU_REQ';
export const MENU_SUCCESS = '@MENU/MENU_SUCCESS';
export const MENU_FAIL = '@MENU/MENU_FAIL';